function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import Button from '@engine/components/presentational/base/button';
import CopyContainer from '@engine/components/presentational/copy-container';
import React from 'react';
import { connect } from 'react-redux';
import { decryptField } from '@engine/actions/creators/decrypt-field';

var DecryptFieldContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(DecryptFieldContainer, _React$Component);

  var _super = _createSuper(DecryptFieldContainer);

  function DecryptFieldContainer() {
    _classCallCheck(this, DecryptFieldContainer);

    return _super.apply(this, arguments);
  }

  _createClass(DecryptFieldContainer, [{
    key: "render",
    value:
    /**
     * Render component
     */
    function render() {
      var _this = this;

      return React.createElement("span", {
        className: "decrypt ".concat(this.selector)
      }, this.canDecrypt && React.createElement(Button, {
        className: "mr-5",
        onClick: function onClick() {
          return _this.decrypt();
        },
        icon: "lock text-warning",
        size: "xs"
      }), this.props.isDecrypted ? React.createElement(CopyContainer, {
        target: this.props.decryptedText
      }) : React.createElement("span", null, this.props.decryptedText));
    }
    /**
     * Computed properties
     */

  }, {
    key: "selector",
    get: function get() {
      return "".concat(this.props.field.toLowerCase(), "-decrypt");
    }
  }, {
    key: "canDecrypt",
    get: function get() {
      return this.props.can_decrypt && !this.props.isDecrypted;
    }
    /**
     * Methods
     */

  }, {
    key: "decrypt",
    value: function decrypt() {
      if (confirm(I18n.t('object.alert.do_you_really_want_to_decrypt'))) {
        this.props.decryptField(this.props.decrypt_path, this.props.field);
      }
    }
  }]);

  return DecryptFieldContainer;
}(React.Component);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    decryptedText: state["decrypt".concat(ownProps.field)].decryptedText,
    isDecrypted: state["decrypt".concat(ownProps.field)].isDecrypted
  };
};

export default connect(mapStateToProps, {
  decryptField: decryptField
})(DecryptFieldContainer);